const TarifasAdapters = {
    
    GET: {

        receive: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    id: item.idproductotarifa || '',
                    idevento: item.idevento || '',
                    idiva: item.idiva || '',
                    idserviciolinea: item.idserviciolinea || '',
                    importe: item.importe || '',
                    label__importe: item.precio + ' €' || '',
                    importeiva: item.importeiva || '',
                    label__importeiva: item.importeiva + ' €' || '',
                    precio: item.precio || '',
                    tarifa: item.tarifa || '',
                    tarifaaplicadaa: item.tarifaaplicadaa || '',
                    diasprecios: item.dias_precios || [],
                }

                return data
            },

            adapter: function (data: any) {

                const dataTemp = data?.data?.data

                const items = dataTemp?.data?.map((item: any) => (this.schema(item)))
                // const items = this.schema(dataTemp)

                return {
                    data: {
                        items
                    },
                    status: data?.status
                }
            }
        },
    },

    POST: {

        receive: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    data: item.data,
                    message: item.message,
                    status: item.status
                }

                return data
            },

            adapter: function (data: any) {

                const dataTemp = data?.data

                const items = this.schema(dataTemp)
                
                return {
                    data: items,
                    status: data?.status
                }
            }
        },

        send: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    idproducto: item.idproducto || '',
                    idserviciolinea: item.idserviciolinea || '',
                    tarifa: item.tarifa || '',
                    tarifaaplicadaa: item.tarifaaplicadaa || '',
                    precio: item.precio || '',
                    idiva: item.idiva || '',
                    importeiva: item.importeiva || '',
                    importe: item.importe || '',
                    diasprecios: item.diasprecios || [],
                }

                return data
            },

            adapter: function (data: any) {

                const items = this.schema(data)

                return {
                    ...items
                }
            }
        },
    },

    PATCH: {

        receive: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    data: item.data,
                    message: item.message,
                    status: item.status
                }

                return data
            },

            adapter: function (data: any) {

                const dataTemp = data?.data

                const items = this.schema(dataTemp)

                
                return {
                    data: items,
                    status: data?.status
                }
            }
        },

        send: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    idproductotarifa: item.id || '',
                    idproducto: item.idproducto || '',
                    idserviciolinea: item.idserviciolinea || '',
                    tarifa: item.tarifa || '',
                    tarifaaplicadaa: item.tarifaaplicadaa || '',
                    precio: item.precio || '',
                    idiva: item.idiva || '',
                    importeiva: item.importeiva || '',
                    importe: item.importe || '',
                    diasprecios: item.diasprecios || [],
                }

                return data
            },

            adapter: function (data: any) {

                const items = this.schema(data)

                return {
                    ...items
                }
            }
        },
    },

    DELETE: {

        receive: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    message: item.message,
                    status: item.status
                }

                return data
            },

            adapter: function (data: any) {

                const dataTemp = data?.data

                const items = this.schema(dataTemp)

                
                return {
                    data: items,
                    status: data?.status
                }
            }
        },
    },
}

export {
    TarifasAdapters
}